import SubMenuIndexes from 'modules/layoutModule/enums/SubMenuIndexes';
import MenuIndexes from 'modules/layoutModule/enums/MenuIndexes';

const currentRouteHelper = (): any => {
  if (window.location.pathname === '/garden/expert-articles/add') {
    return {
      sub: SubMenuIndexes.GARDEN,
      key: MenuIndexes.GARDEN_EXPERT_ARTICLES_ADD,
    };
  }
  if (window.location.pathname.includes('/garden/expert-articles')) {
    return {
      sub: SubMenuIndexes.GARDEN,
      key: MenuIndexes.GARDEN_EXPERT_ARTICLES,
    };
  }
  if (window.location.pathname === '/garden/fertilizers/add') {
    return {
      sub: SubMenuIndexes.GARDEN,
      key: MenuIndexes.GARDEN_FERTILIZERS_ADD,
    };
  }
  if (window.location.pathname.includes('/garden/fertilizers')) {
    return {
      sub: SubMenuIndexes.GARDEN,
      key: MenuIndexes.GARDEN_FERTILIZERS,
    };
  }

  if (window.location.pathname === '/news/add') {
    return {
      sub: SubMenuIndexes.NEWS,
      key: MenuIndexes.NEWS_ADD,
    };
  }
  if (window.location.pathname === '/news/categories/add') {
    return {
      sub: SubMenuIndexes.CONTENT_SETTINGS,
      key: MenuIndexes.NEWS_CATEGORY_ADD,
    };
  }
  if (window.location.pathname.includes('/news/categories')) {
    return {
      sub: SubMenuIndexes.CONTENT_SETTINGS,
      key: MenuIndexes.NEWS_CATS,
    };
  }
  if (window.location.pathname.includes('/news')) {
    return {
      sub: SubMenuIndexes.NEWS,
      key: MenuIndexes.NEWS,
    };
  }
  if (window.location.pathname === '/representatives/add') {
    return {
      sub: SubMenuIndexes.CONTACT,
      key: MenuIndexes.REPRESENTATIVES_ADD,
    };
  }
  if (window.location.pathname === '/fertilization/add') {
    return {
      sub: SubMenuIndexes.KNOWLEDGE,
      key: MenuIndexes.FERTILIZATION_ADD,
    };
  }
  if (window.location.pathname === '/fertilization-schedule/add') {
    return {
      sub: SubMenuIndexes.KNOWLEDGE,
      key: MenuIndexes.FERTILIZATION_SCHEDULE_ADD,
    };
  }
  if (window.location.pathname.includes('/fertilization-schedule')) {
    return {
      sub: SubMenuIndexes.KNOWLEDGE,
      key: MenuIndexes.FERTILIZATION_SCHEDULE,
    };
  }
  if (window.location.pathname.includes('/fertilization')) {
    return {
      sub: SubMenuIndexes.KNOWLEDGE,
      key: MenuIndexes.FERTILIZATION,
    };
  }
  if (window.location.pathname.includes('/ask-expert/add')) {
    return {
      sub: SubMenuIndexes.KNOWLEDGE,
      key: MenuIndexes.ASK_EXPERT_ADD,
    };
  }
  if (window.location.pathname.includes('/ask-expert')) {
    return {
      sub: SubMenuIndexes.KNOWLEDGE,
      key: MenuIndexes.ASK_EXPERT,
    };
  }
  if (window.location.pathname.includes('/banners')) {
    return {
      sub: SubMenuIndexes.BANNERS,
      key: MenuIndexes.BANNERS,
    };
  }
  if (window.location.pathname === '/password') {
    return {
      sub: null,
      key: MenuIndexes.PASSWORD_CHANGE,
    };
  }
  if (window.location.pathname === '/fertilizers/categories/add') {
    return {
      sub: SubMenuIndexes.CONTENT_SETTINGS,
      key: MenuIndexes.FERTILIZERS_CATEGORIES_ADD,
    };
  }
  if (window.location.pathname === '/fertilizers/categories') {
    return {
      sub: SubMenuIndexes.CONTENT_SETTINGS,
      key: MenuIndexes.FERTILIZERS_CATEGORIES,
    };
  }
  if (window.location.pathname === '/fertilizers/pack/add') {
    return {
      sub: SubMenuIndexes.CONTENT_SETTINGS,
      key: MenuIndexes.FERTILIZERS_PACK_ADD,
    };
  }
  if (window.location.pathname === '/gtw-requirements') {
    return {
      sub: SubMenuIndexes.GTW,
      key: MenuIndexes.GTW_REQUIREMENTS,
    };
  }
  if (window.location.pathname === '/gtw-requirements/add') {
    return {
      sub: SubMenuIndexes.GTW,
      key: MenuIndexes.GTW_REQUIREMENTS_ADD,
    };
  }
  if (window.location.pathname.includes('/gtw-requirements')) {
    return {
      sub: SubMenuIndexes.GTW,
      key: MenuIndexes.GTW_REQUIREMENTS,
    };
  }

  if (window.location.pathname === '/gtw-editions') {
    return {
      sub: SubMenuIndexes.GTW,
      key: MenuIndexes.GTW_EDITIONS,
    };
  }
  if (window.location.pathname === '/gtw-editions/add') {
    return {
      sub: SubMenuIndexes.GTW,
      key: MenuIndexes.GTW_EDITIONS_ADD,
    };
  }
  if (window.location.pathname.includes('/gtw-editions')) {
    return {
      sub: SubMenuIndexes.GTW,
      key: MenuIndexes.GTW_EDITIONS,
    };
  }

  if (window.location.pathname === '/agro-lider') {
    return {
      sub: SubMenuIndexes.KNOWLEDGE,
      key: MenuIndexes.AGRO_LIDER,
    };
  }
  if (window.location.pathname === '/agro-lider/add') {
    return {
      sub: SubMenuIndexes.KNOWLEDGE,
      key: MenuIndexes.AGRO_LIDER_ADD,
    };
  }
  if (window.location.pathname.includes('/agro-lider')) {
    return {
      sub: SubMenuIndexes.KNOWLEDGE,
      key: MenuIndexes.AGRO_LIDER,
    };
  }

  if (window.location.pathname.includes('/fertilizers-dictionary')) {
    return {
      sub: SubMenuIndexes.FERTILIZERS,
      key: MenuIndexes.FERTILIZERS_DICTIONARY,
    };
  }

  if (window.location.pathname === '/gtw-files') {
    return {
      sub: SubMenuIndexes.GTW,
      key: MenuIndexes.GTW_FILES,
    };
  }
  if (window.location.pathname === '/gtw-files/add') {
    return {
      sub: SubMenuIndexes.GTW,
      key: MenuIndexes.GTW_FILES_ADD,
    };
  }
  if (window.location.pathname.includes('/gtw-files')) {
    return {
      sub: SubMenuIndexes.GTW,
      key: MenuIndexes.GTW_FILES,
    };
  }

  if (window.location.pathname === '/fertilizers/add') {
    return {
      sub: SubMenuIndexes.FERTILIZERS,
      key: MenuIndexes.FERTILIZERS_ADD,
    };
  }
  if (window.location.pathname === '/fertilizers/pack') {
    return {
      sub: SubMenuIndexes.CONTENT_SETTINGS,
      key: MenuIndexes.FERTILIZERS_PACK,
    };
  }
  if (window.location.pathname === '/gtw-art/add') {
    return {
      sub: SubMenuIndexes.GTW,
      key: MenuIndexes.GTW_ARTICLES_ADD,
    };
  }
  if (window.location.pathname.includes('/gtw-art')) {
    return {
      sub: SubMenuIndexes.GTW,
      key: MenuIndexes.GTW_ARTICLES,
    };
  }
  if (window.location.pathname === '/gtw-categories') {
    return {
      sub: SubMenuIndexes.CONTENT_SETTINGS,
      key: MenuIndexes.GTW_CAT,
    };
  }
  if (window.location.pathname === '/gtw-categories/add') {
    return {
      sub: SubMenuIndexes.CONTENT_SETTINGS,
      key: MenuIndexes.GTW_CAT_ADD,
    };
  }

  if (window.location.pathname === '/fertilizers-parameters/add') {
    return {
      sub: SubMenuIndexes.FERTILIZERS,
      key: MenuIndexes.FERTILIZERS_PARAMETERS_ADD,
    };
  }
  if (window.location.pathname.includes('/gtw-categories/')) {
    return {
      sub: SubMenuIndexes.CONTENT_SETTINGS,
      key: MenuIndexes.GTW_CAT,
    };
  }
  if (window.location.pathname.includes('/fertilizers-parameters')) {
    return {
      sub: SubMenuIndexes.FERTILIZERS,
      key: MenuIndexes.FERTILIZERS_PARAMETERS,
    };
  }
  if (window.location.pathname.includes('/fertilizers/categories')) {
    return {
      sub: SubMenuIndexes.CONTENT_SETTINGS,
      key: MenuIndexes.FERTILIZERS_CATEGORIES,
    };
  }
  if (window.location.pathname.includes('/fertilizers/pack')) {
    return {
      sub: SubMenuIndexes.CONTENT_SETTINGS,
      key: MenuIndexes.FERTILIZERS_PACK,
    };
  }
  if (window.location.pathname.includes('/fertilizers')) {
    return {
      sub: SubMenuIndexes.FERTILIZERS,
      key: MenuIndexes.FERTILIZERS,
    };
  }
  if (window.location.pathname === '/data-protection') {
    return {
      sub: SubMenuIndexes.CONTACT,
      key: MenuIndexes.DATA_PROTECTION,
    };
  }
  if (window.location.pathname === '/service-map') {
    return {
      sub: SubMenuIndexes.CONTACT,
      key: MenuIndexes.SERVICE_MAP,
    };
  }
  if (window.location.pathname === '/privacy') {
    return {
      sub: SubMenuIndexes.CONTACT,
      key: MenuIndexes.PRIVACY,
    };
  }
  if (window.location.pathname === '/rules') {
    return {
      sub: SubMenuIndexes.CONTACT,
      key: MenuIndexes.RULES,
    };
  }
  if (window.location.pathname.includes('/representatives')) {
    return {
      sub: SubMenuIndexes.CONTACT,
      key: MenuIndexes.REPRESENTATIVES_LIST,
    };
  }
  if (window.location.pathname === '/distribution/add') {
    return {
      sub: SubMenuIndexes.CONTACT,
      key: MenuIndexes.DISTRIBUTION_ADD,
    };
  }
  if (window.location.pathname.includes('/distribution')) {
    return {
      sub: SubMenuIndexes.CONTACT,
      key: MenuIndexes.DISTRIBUTION_LIST,
    };
  }
  if (window.location.pathname === '/nawozy-tv/add') {
    return {
      sub: SubMenuIndexes.KNOWLEDGE,
      key: MenuIndexes.NAWOZY_TV_ADD,
    };
  }
  if (window.location.pathname === '/all-categories/add') {
    return {
      sub: SubMenuIndexes.CONTENT_SETTINGS,
      key: MenuIndexes.ALL_CATEGORY_ADD,
    };
  }
  if (window.location.pathname.includes('/all-categories')) {
    return {
      sub: SubMenuIndexes.CONTENT_SETTINGS,
      key: MenuIndexes.ALL_CATEGORY_LIST,
    };
  }
  if (window.location.pathname.includes('/nawozy-tv')) {
    return {
      sub: SubMenuIndexes.KNOWLEDGE,
      key: MenuIndexes.NAWOZY_TV,
    };
  }
  if (window.location.pathname === '/products/categories/add') {
    return {
      sub: SubMenuIndexes.PRODUCTS,
      key: MenuIndexes.PRODUCTS_CATEGORIES_ADD,
    };
  }
  if (window.location.pathname === '/products/categories') {
    return {
      sub: SubMenuIndexes.PRODUCTS,
      key: MenuIndexes.PRODUCTS_CATEGORIES,
    };
  }
  if (window.location.pathname.includes('/products')) {
    return {
      sub: SubMenuIndexes.PRODUCTS,
      key: MenuIndexes.PRODUCTS,
    };
  }
  if (window.location.pathname.includes('/lexicon')) {
    return {
      sub: SubMenuIndexes.LEXICON,
      key: MenuIndexes.LEXICON,
    };
  }
  if (window.location.pathname === '/sections/add') {
    return {
      sub: SubMenuIndexes.CONTENT_SETTINGS,
      key: MenuIndexes.SECTION_ADD,
    };
  }
  if (window.location.pathname.includes('/sections')) {
    return {
      sub: SubMenuIndexes.CONTENT_SETTINGS,
      key: MenuIndexes.SECTION_LIST,
    };
  }
  if (window.location.pathname.includes('/expert-articles/add')) {
    return {
      sub: SubMenuIndexes.KNOWLEDGE,
      key: MenuIndexes.KNOWLEDGE_ADD,
    };
  }
  if (window.location.pathname.includes('/knowledge')) {
    return {
      sub: SubMenuIndexes.KNOWLEDGE,
      key: MenuIndexes.KNOWLEDGE,
    };
  }
  if (window.location.pathname === '/experts-articles/add') {
    return {
      sub: SubMenuIndexes.EXPERT_ARTICLES,
      key: MenuIndexes.EXPERT_ARTICLES_ADD,
    };
  }
  if (window.location.pathname === '/users/add-user') {
    return {
      sub: SubMenuIndexes.SETTINGS,
      key: MenuIndexes.USERS_ADD_USER,
    };
  }
  if (window.location.pathname.includes('/users')) {
    return {
      sub: SubMenuIndexes.SETTINGS,
      key: MenuIndexes.USERS,
    };
  }
  if (window.location.pathname === '/video/add') {
    return {
      sub: SubMenuIndexes.VIDEO,
      key: MenuIndexes.VIDEO_ADD,
    };
  }
  if (window.location.pathname.includes('/video')) {
    return {
      sub: SubMenuIndexes.VIDEO,
      key: MenuIndexes.VIDEO,
    };
  }
  if (window.location.pathname === '/gallery/upload') {
    return {
      sub: SubMenuIndexes.GALLERY,
      key: MenuIndexes.GALLERY_ADD,
    };
  }
  if (window.location.pathname === '/gallery') {
    return {
      sub: SubMenuIndexes.GALLERY,
      key: MenuIndexes.GALLERY,
    };
  }
  if (window.location.pathname === '/expert-articles/categories') {
    return {
      sub: SubMenuIndexes.EXPERT_ARTICLES,
      key: MenuIndexes.EXPERT_ARTICLES_CATEGORIES,
    };
  }
  if (window.location.pathname === '/expert-articles/add') {
    return {
      sub: SubMenuIndexes.EXPERT_ARTICLES,
      key: MenuIndexes.EXPERT_ARTICLES_ADD,
    };
  }
  if (window.location.pathname === '/expert-articles/categories/add') {
    return {
      sub: SubMenuIndexes.EXPERT_ARTICLES,
      key: MenuIndexes.EXPERT_ARTICLES_CATEGORY_ADD,
    };
  }
  if (window.location.pathname.includes('/expert-articles/categories/')) {
    return {
      sub: SubMenuIndexes.EXPERT_ARTICLES,
      key: MenuIndexes.EXPERT_ARTICLES_CATEGORIES,
    };
  }
  if (window.location.pathname.includes('/expert-articles')) {
    return {
      sub: SubMenuIndexes.KNOWLEDGE,
      key: MenuIndexes.KNOWLEDGE,
    };
  }
  if (window.location.pathname === '/gallery/categories') {
    return {
      sub: SubMenuIndexes.GALLERY,
      key: MenuIndexes.GALLERY_CATEGORIES,
    };
  }
  if (window.location.pathname === '/field-news/add') {
    return {
      sub: SubMenuIndexes.NEWS,
      key: MenuIndexes.FIELD_NEWS_ADD,
    };
  }
  if (window.location.pathname.includes('/field-news')) {
    return {
      sub: SubMenuIndexes.NEWS,
      key: MenuIndexes.FIELD_NEWS,
    };
  }
  if (window.location.pathname === '/multimedia/add') {
    return {
      sub: SubMenuIndexes.MULTIMEDIA,
      key: MenuIndexes.MULTIMEDIA_ADD,
    };
  }
  if (window.location.pathname.includes('/multimedia')) {
    return {
      sub: SubMenuIndexes.MULTIMEDIA,
      key: MenuIndexes.MULTIMEDIA,
    };
  }
  if (window.location.pathname === '/') {
    return {
      sub: '',
      key: MenuIndexes.HOME,
    };
  }
  return '';
};
export default currentRouteHelper;
